export default {
    GROUP_INIT: function(state, data) {
        state.group = data.group
        state.group.groupModule = data.groupModule
    }
}